import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import styles from "./AskTheTeamStyles.module.css";
import "../AdvanceFilters/AFModalsStyles.css";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VizButtons from "../../VizButtons/VizButton";
import MultiSelect from "../../MultiSelect/MultiSelect";
import { rfpUpload } from "../../../API/api";
import { toast } from "react-toastify";
import MultiselectCM from "../../MultiSelectCm/MultiSelectCm";
import { ReactComponent as MultiQIcon } from "../../../Icons/MultiQIcon.svg";
import { ReactComponent as UploadIcon } from "../../../Icons/upload.svg";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { CURRENT_ROLE } from "../../../API/url";
// import {ButtonTwo as Button} from '../../../NewComponent/Button/Button';

const submitSuccessToast = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export function RFPUploadModal() {
  const navigate = useNavigate();
  const userState = useSelector((state) => state.user);
  const [islanguage, setIsLanguage] = useState("English");
  const [selected, setSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDomains, setSelectedDomains] = useState([]);
  const [selectedDocType, setSelectedDocType] = useState({
    label: "All",
    name: "All",
    value: "All",
  });
  const [type, setType] = useState("Detailed");
  const modalState = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle } = bindActionCreators(Actions, dispatch);
  const [isImgShow, setShow] = useState(false);
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
    // color:'red'
  });
  const onChangeFile = (e) => {
    setSelected([]);
    setSelected([e.target.files[0]]);
  };
  const onClickCancel = () => {
    advanceFilterModalToggle({ bool: false, value: "" });
  };
  const onClickSubmit = () => {
    let obj = {
      language: islanguage,
      type: type,
      domainIds:
        selectedDomains.length === 0
          ? ""
          : selectedDomains
              .map((domain) => domain.indexId)
              .sort()
              .toString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      source:
        selectedDocType.label === "All" ? undefined : selectedDocType.label,
    };
    let fd = new FormData();
    fd.append("file", selected[0]);
    fd.append("metadata", JSON.stringify(obj));
    rfpUpload(fd).then((res) => {
      if (res === undefined) return;
      advanceFilterModalToggle({ bool: false, value: "" });
      if (res.data.success) {
        toast.success(submitSuccessToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };
  const onChangeLanguage = (lang) => {
    setIsLanguage(lang);
  };
  const onChangeType = (type) => {
    setType(type);
  };

  const onChangeDomain = (domain) => {
    setSelectedDomains(domain);
  };
  const onChangeDocType = (docType) => {
    setSelectedDocType(docType);
  };
  useEffect(() => {}, []);
  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        size="lg"
        dialogClassName="rfp-upload-modal"
        // centered={true}
        backdrop={"static"}
        style={{ marginTop: "5%" }}
      >
        <Modal.Header closeButton closeVariant="gray">
          <Modal.Title className="titleText">Upload File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12 col-lg-12">
            <div
              style={{
                width: "100%",
                textAlign: "center",
                // border: "2px dotted lightgrey",
                borderRadius: "8px",
                padding: "30px",
                // backgroundColor: "#F8FCFF",
              }}
            >
              <div>
                <MultiQIcon />
              </div>
              <div
                style={{
                  padding: "20px",
                }}
              >
                <span className="subTextTitle">
                  To have Vizerto explore your questions further, please upload
                  an Excel (.xls) file with up to 25 questions in a single
                  column. You will get a notification when it is complete. It
                  will be available to view under{" "}
                  <span
                    onClick={() => {
                      advanceFilterModalToggle({ bool: false, value: "" });
                      console.log(CURRENT_ROLE);
                      if (CURRENT_ROLE === "Seeker")
                        navigate("/seekerHome/download");
                    }}
                    style={{
                      color: "#1677ff",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    My Files
                  </span>
                  <span>.</span>
                </span>
                <div>
                  <span className="subTextTitle">
                    File Format:{" "}
                    <img
                      onClick={() => setShow(true)}
                      style={{ cursor: "pointer", border: "1px solid #f2f2f2" }}
                      width={"50px"}
                      height={"30px"}
                      src={require("../../../Images/rfp2.png")}
                    />
                  </span>
                </div>
              </div>
              <div style={{ paddingBlock: "7px" }}>
                <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  style={{
                    padding: "14px 24px 14px 24px",
                    textTransform: "none",
                    border: "1px solid #F6F7F8",
                    height: "42px",
                    width: "160px",
                    background: "#FFFFFF",
                    boxShadow: "0px 1px 2px 0px #1018280D",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#2A364A",
                    fontWeight: "100",
                  }}
                  // startIcon={}
                >
                  <UploadIcon />
                  Upload File
                  <VisuallyHiddenInput
                    type="file"
                    accept={".xls, .xlsx"}
                    onChange={(e) => onChangeFile(e)}
                  />
                </Button>
              </div>
              {selected.length !== 0 && (
                <div>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "black",
                      fontWeight: "100",
                      color: "grey",
                    }}
                  >
                    <span style={{ fontSize: "14px", color: "green" }}>
                      <i class="fa fa-file-excel-o"></i>{" "}
                    </span>
                    {selected[0].name}
                  </span>
                </div>
              )}
            </div>
            <div
              className="mt-2"
              style={{
                padding: "16px",
                display: "flex",
                background: "#F6F7F8",
                justifyContent: "space-between",
                marginBottom: "-16px",
                marginInline: "-16px",
                borderEndEndRadius: "10px",
                borderEndStartRadius: "10px",
              }}
            >
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                <div>
                  <Select
                    style={{ width: 150, textAlign: "left" }}
                    dropdownStyle={{ textAlign: "left" }}
                    placeholder="Select Language"
                    value={islanguage}
                    onChange={onChangeLanguage}
                    options={userState.multipleLanguages.map((lang) => ({
                      label: lang,
                      value: lang,
                    }))}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </div>
                &nbsp;&nbsp;
                <div>
                  <Select
                    dropdownStyle={{ textAlign: "left" }}
                    style={{ width: 150, textAlign: "left" }}
                    placeholder="Select Type"
                    value={type}
                    onChange={onChangeType}
                    options={[
                      { label: "Detailed", value: "Detailed" },
                      { label: "Short", value: "Summary" },
                    ]}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </div>
                &nbsp;&nbsp;
                <div>
                  <Select
                    mode="multiple"
                    style={{ width: 200, textAlign: "left" }}
                    dropdownStyle={{ textAlign: "left" }}
                    placeholder="Select Domains"
                    value={(selectedDomains || []).map((d) =>
                      Number(d.indexId)
                    )}
                    onChange={(values) => {
                      // Map values back to full objects from userState.expertTopics
                      const fullObjects = userState.expertTopics.filter(
                        (topic) => values.includes(topic.indexId)
                      );
                      onChangeDomain(fullObjects);
                    }}
                    options={
                      userState?.expertTopics?.map((d) => ({
                        label: d.name,
                        value: Number(d.indexId),
                      })) || []
                    }
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    // show "X selected" pill
                    maxTagCount={selectedDomains.length ? 0 : undefined}
                    maxTagPlaceholder={() =>
                      selectedDomains.length ? (
                        <span className="rfp-domain-select-count">
                          {selectedDomains.length} selected
                        </span>
                      ) : null
                    }
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </div>
                &nbsp;&nbsp;
                <div>
                  <Select
                    dropdownStyle={{ textAlign: "left" }}
                    style={{ width: 150, textAlign: "left" }}
                    placeholder="Select Document Type"
                    value={selectedDocType?.value}
                    onChange={(val) =>
                      onChangeDocType({ label: val, value: val, name: val })
                    }
                    options={[
                      { label: "All", value: "All" },
                      { label: "Expert QA", value: "Expert QA" },
                      { label: "Pdf", value: "Pdf" },
                      { label: "Video", value: "Video" },
                      { label: "Image", value: "Image" },
                      { label: "Url", value: "Url" },
                      { label: "Thread", value: "Thread" },
                    ]}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </div>
              </div>
              <div style={{ float: "right" }}>
                <button className="buttonPrimary" onClick={onClickSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div>
        <Modal
          show={isImgShow}
          onHide={() => setShow(false)}
          centered={true}
          size="lg"
        >
          <Modal.Body style={{ textAlign: "center" }}>
            <img
              style={{ width: "100%" }}
              src={require("../../../Images/rfp2.png")}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
